import useTranslateParse from 'util/useTranslateParse'

const Subtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <div>
      {translateParse(
        'Configure webhooks to receive notifications when changes occur in OpenSolar. To learn more about webhooks, <a>visit the API documentation<a>.',
        {
          a: (label) => (
            <a
              href={'https://developers.opensolar.com/api/webhooks'}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', whiteSpace: 'nowrap', color: 'rgb(24, 144, 255)' }}
            >
              {label}
            </a>
          ),
        }
      )}
    </div>
  )
}

export default {
  list: { lazy: () => import('./Webhooks'), component: 'WebhooksList' },
  edit: { lazy: () => import('./Webhooks'), component: 'WebhooksEdit' },
  create: { lazy: () => import('./Webhooks'), component: 'WebhooksCreate' },
  options: {
    create: {
      title: 'Create Webhook',
      breadCrumb: 'Create Webhook',
      subtitle: <Subtitle />,
    },
    list: {
      title: 'Webhooks',
      breadCrumb: 'Webhooks',
      subtitle: <Subtitle />,
    },
    edit: {
      title: 'Edit Webhook',
      breadCrumb: 'Edit Webhook',
      subtitle: null,
    },
  },
}
